module.exports = __webpack_public_path__ + "static/img/2022logo.0b31ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2022logo.png
// module id = soDn
// module chunks = 1